export default __webpack_public_path__ + "static/media/shap_tecture.5923429e.png";